import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-de",
  "use": "icon-flag-de-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-de\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 819.2h1024V204.8H0z\" fill=\"#000000\" p-id=\"4700\" /><path d=\"M0 819.2h1024V409.6H0z\" fill=\"#DD0000\" p-id=\"4701\" /><path d=\"M0 819.2h1024V614.4H0z\" fill=\"#FFCE00\" p-id=\"4702\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-de.svg
// module id = TeVf
// module chunks = 24